import Vue from 'vue';
import VueRouter from 'vue-router';
import Intro from '@/components/Intro';
import Home from '@/components/Home';
import Looks from '@/components/Looks';
import Look from '@/components/Look';

Vue.use(VueRouter);

const router = new VueRouter({
  linkActiveClass: 'active',
  mode: 'hash',
  base: '/',
  routes: [
    { path: '/', name: 'intro', component: Intro },
    { path: '/home', name: 'home', component: Home },
    { path: '/looks/:gender', name: 'looks', component: Looks },
    { path: '/looks/:gender/:id', name: 'look', component: Look },
  ],
});

// Check Param Globally
router.beforeEach((to, from, next) => {
  // Validate genders if param exists
  const validGenders = ['women', 'men'];
  if (to.params.gender && validGenders.indexOf(to.params.gender) === -1) {
    return next({ name: 'home' });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js